import formStyle from '../style/WForm.less';
import * as React from 'react';

interface WFormFieldCheckboxProps extends React.ClassAttributes<any> {
    label: JSX.Element;
    name: string;
    value: string;
    required?: boolean;
    readonly?: boolean;
    disabled?: boolean;
    style?: any;
    onValueChange(name: string, value: any): void;
}

export class WFormFieldCheckbox extends React.Component<WFormFieldCheckboxProps, {}> {

    constructor(props: any) {
        super(props);
        this.onInputChange = this.onInputChange.bind(this);
    }

    onInputChange(event: any): void {
        this.props.onValueChange(this.props.name, event.target.checked ? '1' : '0');
    }

    render(): JSX.Element {
        const disabled = this.props.readonly || this.props.disabled ? true : false;
        const style: any = this.props.style || {};
        const styleInput: React.CSSProperties = style.classInput || {};
        const styleInputText: React.CSSProperties = style.classInputText || {};

        return (
            <div
                className={formStyle.fieldBox}
                style={style}
            >
                {this.props.label}
                <div
                    className={formStyle.input}
                    style={styleInput}
                >
                    <input
                        style={styleInputText}
                        type='checkbox'
                        className={formStyle.inputText}
                        name={this.props.name}
                        checked={this.props.value && +this.props.value === 1}
                        // readOnly = {disabled}
                        disabled={disabled}
                        onChange={this.onInputChange}
                    />
                </div>
            </div>
        );
    }
}
